import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const Jobs = () => {
  // Sample data
  const data = [
    { id: 1, group: "Group A", name: "Item 1", value: "Value 1" },
    { id: 2, group: "Group A", name: "Item 2", value: "Value 2" },
    { id: 3, group: "Group B", name: "Item 3", value: "Value 3" },
    { id: 4, group: "Group B", name: "Item 4", value: "Value 4" },
  ];

  // Columns definition
  const columns = [
    {
      dataField: "group",
      text: "Group",
      formatter: (cell, row, rowIndex) => {
        const previousRow = rowIndex > 0 ? data[rowIndex - 1] : null;
        const showGroup = !previousRow || previousRow.group !== row.group;
        return showGroup ? <strong>{cell}</strong> : "";
      },
      formatExtraData: data,
    },
    { dataField: "name", text: "Name" },
    { dataField: "value", text: "Value" },
  ];

  // Custom row style for grouped rows
  const rowStyle = (row, rowIndex) => {
    const previousRow = rowIndex > 0 ? data[rowIndex - 1] : null;
    const showGroup = !previousRow || previousRow.group !== row.group;
    return {
      backgroundColor: showGroup ? "#f8f9fa" : "#ffffff",
    };
  };

  return (
    <div>
      <h3>Table with Grouping (Colspan Effect)</h3>
      <BootstrapTable
        keyField="id"
        data={data}
        columns={columns}
        pagination={paginationFactory()}
        rowStyle={rowStyle}
      />
    </div>
  );
};

export default Jobs;
